import { z } from "zod";
const secondsSchema = z.number().brand();
function asSeconds(value) {
  return secondsSchema.parse(value);
}
const millisSchema = z.number().brand();
function asMillis(value) {
  return millisSchema.parse(value);
}
function millisFromSeconds(seconds) {
  return asMillis(seconds * 1e3);
}
export {
  asMillis,
  asSeconds,
  millisFromSeconds,
  millisSchema,
  secondsSchema
};
//# sourceMappingURL=duration.js.map
